export const communicationPreferencesUpdateSuccess =
  'Communication preferences successfully updated.';
